import React, { useState } from 'react';
import { 
  Radio, 
  ShieldAlert, 
  Database, 
  ExternalLink, 
  Clock, 
  AlertTriangle,
  Flame,
  Search
} from 'lucide-react';

export const DarkWebFeedPage: React.FC = () => {
  const [filter, setFilter] = useState('all');

  const breachEvents = [
    {
      id: 'dw-101',
      source: 'BreachForums / Russian Tor Onion Node',
      target: 'Australian Logistics & Freight Express',
      dataExposed: ['Names', 'Driver Licences', 'Delivery Notes', 'Phone Numbers'],
      recordCount: '480,000 Australian records',
      detectedAt: 'Today at 04:12 AM AEST',
      severity: 'CRITICAL',
      status: 'Quarantined & Hashed into IDFraud Engine'
    },
    {
      id: 'dw-102',
      source: 'Private Telegram Leak Channel',
      target: 'Sydney Regional Dental & Orthodontics Group',
      dataExposed: ['Medicare Numbers', 'Patient Medical Claims', 'DOB', 'Addresses'],
      recordCount: '62,000 Patient Records',
      detectedAt: 'Yesterday at 9:40 PM AEST',
      severity: 'HIGH',
      status: 'Notified Affected IDFraud.au Users'
    },
    {
      id: 'dw-103',
      source: 'RansomHub Extortion Portal',
      target: 'Victorian Legal & Conveyancing Firm',
      dataExposed: ['Passport Scans', 'Contract of Sale PDFs', 'Bank Account Numbers'],
      recordCount: '14,200 Client Files',
      detectedAt: '17 August 2026',
      severity: 'CRITICAL',
      status: 'PEXA & Law Society Alert Dispatched'
    },
    {
      id: 'dw-104',
      source: 'ComboList Ingestion Pipeline',
      target: 'Australian Retail Ecommerce Storefronts',
      dataExposed: ['Plaintext Passwords', 'Email Hashes', 'Order Histories'],
      recordCount: '1,200,000 Credentials',
      detectedAt: '15 August 2026',
      severity: 'MEDIUM',
      status: 'Credential Stuffing Defenses Updated'
    }
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-950 text-rose-300 text-xs font-bold border border-rose-800">
            <Radio className="w-3.5 h-3.5 animate-pulse text-rose-400" />
            <span>LIVE DARK WEB INTELLIGENCE STREAM</span>
          </div>
          <h1 className="text-3xl font-extrabold text-white mt-1">Dark Web Breach Telemetry Feed</h1>
        </div>
        <span className="text-xs text-emerald-400 font-mono font-bold bg-slate-900 border border-slate-800 px-3 py-1.5 rounded-xl">
          ● 24/7 Scraping Active
        </span>
      </div>

      <div className="space-y-4">
        {breachEvents.map((ev) => (
          <div
            key={ev.id}
            className="bg-slate-900 border border-slate-800 rounded-3xl p-6 shadow-xl space-y-3 hover:border-slate-700 transition-all text-xs"
          >
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-b border-slate-800 pb-3">
              <div className="flex items-center gap-2">
                <span className="font-bold text-white text-sm">{ev.target}</span>
                <span className="text-slate-500 font-mono text-[10px]">({ev.source})</span>
              </div>
              <div className="flex items-center gap-2">
                <span className={`px-2.5 py-0.5 rounded text-[10px] font-bold uppercase ${
                  ev.severity === 'CRITICAL' ? 'bg-rose-950 text-rose-300 border border-rose-800' : 'bg-amber-950 text-amber-300 border border-amber-800'
                }`}>
                  {ev.severity}
                </span>
                <span className="text-slate-400 font-mono text-[11px]">{ev.detectedAt}</span>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <span className="text-slate-400 block mb-1">Exposed Australian Data Classes:</span>
                <div className="flex flex-wrap gap-1">
                  {ev.dataExposed.map((d, i) => (
                    <span key={i} className="px-2 py-0.5 rounded bg-slate-950 border border-slate-800 text-[10px] text-slate-300">
                      {d}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <span className="text-slate-400 block mb-1">Estimated Impact & Ingestion:</span>
                <div className="text-white font-mono">{ev.recordCount}</div>
                <div className="text-emerald-400 text-[11px]">{ev.status}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
